import ZoomScroll from './ZoomScroll';


/**
 * @type { import('didi').ModuleDeclaration }
 */
export default {
  __init__: [ 'zoomScroll' ],
  zoomScroll: [ 'type', ZoomScroll ]
};